"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpandedSelection = void 0;
const remirror_1 = require("remirror");
const react_1 = require("@remirror/react");
/**
 * Returns a single range that is either:
 * 1. The current selection if the current selection does not contain any of the indicated marks.
 * 2. An expanded version of the current selection if the range contains any of the indicated marks.
 *
 * For example, given the content:
 *
 * <strong>Bold</strong> regular <u>underline</u> <u>more underline</u>
 *
 * If the marks passed in are 'bold' and 'underline' and the text "old regular under" is selected
 * the returned range will be "Bold regular underline".
 *
 * @param {(MarkType|string)[]} markTypes
 *
 * @return {ExpandedSelection}
 */
const useExpandedSelection = (markTypes) => {
    const { doc, selection } = (0, react_1.useEditorState)();
    const ranges = [];
    markTypes.forEach((markType) => {
        ranges.push(...(0, remirror_1.getMarkRanges)(selection, markType));
    });
    if (ranges.length === 0) {
        return { selection, marks: [] };
    }
    // work out the start position of the first link and end position of the last link in the selection.
    const from = Math.min(selection.from, ...ranges.map((range) => range.from));
    const to = Math.max(selection.to, ...ranges.map((range) => range.to));
    const marks = ranges.map((range) => range.mark);
    return { selection: (0, remirror_1.getTextSelection)({ from, to }, doc), marks };
};
exports.useExpandedSelection = useExpandedSelection;
